import { Button, Drawer } from "antd";
import { useColConfigContext } from "./useColConfig";
import TableConfig from "@components/tableConfigDrawer";
import { cloneDeep } from "lodash";
import { FilterColumnRemoval } from "@components/filters/colFilters";

const DrawerHeader = ({ resetDefaultTableConfig , filteredInfo}: any) => {
  return (
    <Button type="link" className="clr-blueLink" style={{ fontWeight: "normal" }} onClick={() => resetDefaultTableConfig({filteredInfo : filteredInfo})}>
      Reset to default View
    </Button>
  );
};

const DrawerFooter = ({ onCloseConfigDrawer, updateTableConfig }: any) => {
  return (
    <div style={{ textAlign: "right" }} className="cancel-button">
      <Button type="text" size="large" onClick={onCloseConfigDrawer}>
        {" "}
        Cancel{" "}
      </Button>
      <Button type="primary" onClick={updateTableConfig} style={{ height: "40px" }}>
        Update Table
      </Button>
    </div>
  );
};

const DrawerView = ({ tableConfigCallback, tempTableConfig, columnFilterCheck, filteredInfo }: any) => {
  return <TableConfig configUpdatehandler={tableConfigCallback} tableConfigData={cloneDeep(tempTableConfig)} columnFilterCheck={columnFilterCheck} filteredInfo={filteredInfo} />;
};

export function GenericColumnConfig({ filteredInfo, columnListData, getColumns, reportName }: any) {
  const { updateTableConfig, resetDefaultTableConfig, onCloseConfigDrawer, isOpenDrawer, tableConfigCallback, tempTableConfig, columnFilterCheck, isFilterModal, filterModalOk, filterModalCancel } =
    useColConfigContext();

  return (
    <>
      <Drawer
        destroyOnClose={true}
        title={"Select column to display"}
        placement="right"
        closable={false}
        onClose={onCloseConfigDrawer}
        open={isOpenDrawer}
        key="right"
        width={"580"}
        bodyStyle={{ padding: 16 }}
        className={`membersListingDrawer ${"tableConfigDrawer"}`}
        footer={<DrawerFooter onCloseConfigDrawer={onCloseConfigDrawer} updateTableConfig={() => updateTableConfig({ columnListData, getColumns, reportName })} />}
        extra={<DrawerHeader resetDefaultTableConfig={resetDefaultTableConfig}  filteredInfo={filteredInfo}/>}
      >
        {<DrawerView tableConfigCallback={tableConfigCallback} columnFilterCheck={columnFilterCheck} tempTableConfig={tempTableConfig} filteredInfo={filteredInfo} />}
      </Drawer>
      <FilterColumnRemoval isModalOpen={isFilterModal.open} handleOk={() => filterModalOk()} action={isFilterModal.action} handleCancel={() => filterModalCancel()} colNames={isFilterModal.colNames} />
    </>
  );
}
